import { render, staticRenderFns } from "./ReportDownloads.vue?vue&type=template&id=2bb3ebf2"
import script from "./ReportDownloads.vue?vue&type=script&lang=js"
export * from "./ReportDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports